import { FINDING_LABELS } from '@totem/components/services/assetInventory/v2/checks';
import { FilterField } from '@totem/components/ui_components/reportSettings/types';
import { ControlSystemType } from '@totem/types/controlSystem';
import { controlSystemTypeMap } from '@totem/utilities/controlSystemsUtilities';

export const getSystemTypeLabel = (systemType: number) =>
  controlSystemTypeMap[systemType]?.text ?? 'Other';

export const assetInventoryV2Configuration: FilterField[] = [
  {
    key: 'systemType',
    label: 'Building System',
    sortField: 'systemType',
    filterField: 'systemType',
    multiple: true,
    values: [],
    options: Object.values(controlSystemTypeMap)
      .filter((option) => option.value !== ControlSystemType.Unset)
      .map((option) => ({ text: option.text, value: String(option.value) })),
  },
  {
    key: 'building',
    label: 'Building',
    sortField: 'building.name',
    filterField: 'buildingId',
    multiple: true,
    values: [],
  },
  {
    key: 'region',
    label: 'Region',
    sortField: 'region.name',
    filterField: 'regionId',
    multiple: true,
    values: [],
  },
  {
    key: 'type',
    label: 'Type',
    sortField: 'type',
    filterField: 'type',
    multiple: true,
    values: [],
  },
  {
    key: 'vendor',
    label: 'Vendor',
    sortField: 'vendor',
    filterField: 'vendor',
    multiple: true,
    values: [],
  },
  {
    key: 'isMonitored',
    label: 'Monitored',
    sortField: '',
    filterField: 'flags.monitored.status',
    multiple: true,
    values: [],
    hideFilterChips: true,
  },
  {
    key: 'finding',
    label: 'Finding',
    sortField: '',
    filterField: 'finding',
    multiple: true,
    values: [],
    options: Object.entries(FINDING_LABELS).map(([value, text]) => ({
      text,
      value,
    })),
    allowPersistence: false,
    hideFilterChips: true,
  },
  {
    key: 'search',
    label: 'Search',
    sortField: '',
    filterField: 'search',
    multiple: false,
    value: '',
    allowPersistence: false,
  },
  {
    key: 'name',
    label: 'Name',
    sortField: 'name',
    filterField: '',
    multiple: false,
  },
  {
    key: 'operatingSystem',
    label: 'OS',
    sortField: 'operatingSystem',
    filterField: '',
    multiple: false,
  },
  {
    key: 'firmware',
    label: 'Firmware',
    sortField: 'firmware',
    filterField: '',
    multiple: false,
  },
  {
    key: 'isManaged',
    label: 'Managed',
    sortField: 'isManaged',
    filterField: '',
    multiple: false,
  },
  {
    key: 'lastBackup',
    label: 'Last backup',
    sortField: 'lastBackup',
    filterField: '',
    multiple: false,
  },
  {
    key: 'endOfSupport',
    label: 'Support',
    sortField: 'endOfSupport',
    filterField: '',
    multiple: false,
  },
  {
    key: 'serviceStatus',
    label: 'Service',
    sortField: 'serviceStatus',
    filterField: '',
    multiple: false,
  },
];

// Filters that only narrow the Details tab; the Summary and Flagged Items tabs ignore them.
export const DETAILS_ONLY_FILTERS = ['finding', 'search'];
